import script from "./whDOnceImg5_t3B.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg5_t3B.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg5_t3B.vue?vue&type=style&index=0&id=2e0a48b1&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0a48b1"]])

export default __exports__